import { Fragment } from 'react';

import { getCurrencySymbol } from '@utils/utils';
import { PriceProps } from '@components/ui/price/type';
import { getNumberParts } from '@components/ui/price/utils';

import {
  Container,
  Currency,
  Decimals,
  DecimalsCurrency,
  Whole,
  WithOriginalPrice,
} from './priceStyle';

const Price = ({
  price,
  currency = 'TL',
  color = 'darkGrey',
  originalPrice,
  Wrapper = originalPrice ? WithOriginalPrice : Fragment,
  format = 'normal',
  currencyFontSize,
  currencyFontWeight = 400,
  showDecimal = true,
  decimalCurrencyFlexDirection = 'column',
  sellingPrice,
  children,
  priceInEuro,
  priceInEUR,
  ...rest
}: PriceProps) => {
  const [whole, decimal] = getNumberParts(sellingPrice ? sellingPrice : price);
  const [wholePriceInEUR] = getNumberParts(priceInEUR ? priceInEUR : 0);
  const priceControl = whole === wholePriceInEUR;
  return (
    <Wrapper {...rest}>
      {children}
      <Container
        color={color}
        format={format}
        centered
        decimalFontSize={priceInEuro ? 18 : 24}
      >
        {!priceControl ? (
          <>
            <Whole
              fontWeight={priceInEuro ? 400 : 600}
              fontSize={priceInEuro ? 18 : 24}
            >
              {whole}
            </Whole>

            <DecimalsCurrency
              decimalCurrencyFlexDirection={decimalCurrencyFlexDirection}
            >
              {showDecimal ? (
                <Decimals fontWeight={priceInEuro ? 400 : 600}>
                  ,{decimal}
                </Decimals>
              ) : null}
              <Currency
                fontSize={priceInEuro ? currencyFontSize : 24}
                fontWeight={priceInEuro ? currencyFontWeight : 600}
              >
                {getCurrencySymbol(currency) || currency}
              </Currency>
            </DecimalsCurrency>
          </>
        ) : null}
      </Container>
    </Wrapper>
  );
};

export default Price;
